import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useMercenary } from '../../../contexts/MercenaryContext';
import styles from './MercenaryAdvancements.module.css';
import { formatDate } from '../../../utils/dateFormat';

interface Advancement {
  advancementKey: string;
  advancementName: string;
  advancementDescription: string;
  earnedAt: string;
}

const MercenaryAdvancements: React.FC = () => {
  const { mercenary } = useMercenary();
  const [advancements, setAdvancements] = useState<Advancement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!mercenary) return;
    const fetch = async () => {
      try {
        const res = await axios.get('/api/mercenary/advancements', { withCredentials: true });
        setAdvancements(res.data);
      } catch {
        setError('Failed to load advancements.');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [mercenary]);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Advancements</h1>

      {loading && <p className={styles.loading}>Loading…</p>}
      {error && <p className={styles.error}>{error}</p>}

      {!loading && !error && advancements.length === 0 && (
        <p className={styles.empty}>
          No advancements earned yet. Keep fighting!
        </p>
      )}

      {!loading && !error && advancements.length > 0 && (
        <>
          <p className={styles.count}>{advancements.length} advancement{advancements.length !== 1 ? 's' : ''} earned</p>
          <div className={styles.grid}>
            {advancements.map(adv => (
              <div key={adv.advancementKey} className={styles.card}>
                <div className={styles.cardIcon}>⚔</div>
                <div className={styles.cardBody}>
                  <div className={styles.cardName}>{adv.advancementName}</div>
                  <div className={styles.cardDesc}>{adv.advancementDescription}</div>
                  <div className={styles.cardDate}>
                    {formatDate(adv.earnedAt)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MercenaryAdvancements;
